import { __rest, __assign } from 'tslib';
import React, { forwardRef, useContext, useRef, isValidElement, cloneElement } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { Drawer } from '@alfalab/core-components-drawer/esm';
import { ContentDesktop } from '../components/content/Component.desktop.js';
import { Controls } from '../components/controls/Component.js';
import { FooterDesktop } from '../components/footer/Component.desktop.js';
import { Header } from '../components/header/Component.js';
import { SIZE_TO_CLASSNAME_MAP } from '../consts.js';
import { ResponsiveContext } from '../ResponsiveContext.js';

var styles = {"size-500":"side-panel__size-500_1ces5","hidden":"side-panel__hidden_1ces5"};
require('./desktop.css')

var transitions = {"enterRight":"side-panel__enterRight_1uu55","enterLeft":"side-panel__enterLeft_1uu55","enterActive":"side-panel__enterActive_1uu55","exit":"side-panel__exit_1uu55","exitActiveRight":"side-panel__exitActiveRight_1uu55","exitActiveLeft":"side-panel__exitActiveLeft_1uu55"};
require('./transitions.desktop.css')

var SidePanelDesktopComponent = forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 500 : _d, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, _e = _a.contentTransitionProps, contentTransitionProps = _e === void 0 ? {} : _e, backdropProps = _a.backdropProps, _f = _a.placement, placement = _f === void 0 ? 'right' : _f, dataTestId = _a.dataTestId, restProps = __rest(_a, ["size", "children", "className", "wrapperClassName", "contentTransitionProps", "backdropProps", "placement", "dataTestId"]);
    var responsiveContext = useContext(ResponsiveContext);
    var modalRef = useRef(null);
    var enterCn = cn((_b = {},
        _b[transitions.appearRight] = placement === 'right',
        _b[transitions.appearLeft] = placement === 'left',
        _b));
    var exitCn = cn((_c = {},
        _c[transitions.exitActiveRight] = placement === 'right',
        _c[transitions.exitActiveLeft] = placement === 'left',
        _c));
    var contextValue = React.useMemo(function () { return ({ size: size, view: 'desktop', dataTestId: dataTestId }); }, [size, dataTestId]);
    var renderContent = function () { return (React.createElement(Drawer, __assign({}, restProps, { dataTestId: dataTestId, ref: mergeRefs([ref, modalRef]), placement: placement, wrapperClassName: wrapperClassName, className: cn(className, styles[SIZE_TO_CLASSNAME_MAP[size]], styles.hidden), backdropProps: backdropProps, contentTransitionProps: __assign({ classNames: {
                appear: enterCn,
                enter: enterCn,
                appearActive: transitions.enterActive,
                enterActive: transitions.enterActive,
                exit: transitions.exit,
                exitActive: exitCn,
                exitDone: exitCn,
            } }, contentTransitionProps) }), React.Children.map(children, function (child) {
        return isValidElement(child) ? cloneElement(child, { size: size }) : child;
    }))); };
    var renderWithContext = function () { return (React.createElement(ResponsiveContext.Provider, { value: contextValue }, renderContent())); };
    return responsiveContext ? renderContent() : renderWithContext();
});
var HeaderDesktop = Header;
var ControlsDesktop = Controls;
var SidePanelDesktop = Object.assign(SidePanelDesktopComponent, {
    Content: ContentDesktop,
    Header: HeaderDesktop,
    Footer: FooterDesktop,
    Controls: ControlsDesktop,
});

export { ContentDesktop, ControlsDesktop, FooterDesktop, HeaderDesktop, SidePanelDesktopComponent as SidePanelComponentDesktop, SidePanelDesktop };
